import axios from "../../lib/axiosInstance";

export async function fetchTeams(params = {}) {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.search?.trim()) queryParams.append("search", params.search.trim());
  if (params.departmentId) queryParams.append("departmentId", params.departmentId);

  const queryString = queryParams.toString();
  return axios.get(`/teams${queryString ? `?${queryString}` : ""}`).then((res) => res.data);
}

export async function getTeamById(id) {
  return axios.get(`/teams/${id}`).then((res) => res.data);
}

export async function fetchTeamMembersByTeamIds(teamIds) {
  const query = teamIds ? `?teamIds=${Array.isArray(teamIds) ? teamIds.join(",") : teamIds}` : "";

  return axios.get(`/teams/teamMembers${query}`).then((res) => res.data);
}

export async function createTeam(payload) {
  return axios.post(`/teams`, payload).then((res) => res.data);
}

export async function updateTeam(payload) {
  return axios
    .patch(`/teams/${payload.id}`, {
      name: payload.name,
      email: payload.email,
      members: payload.members,
      departmentId: payload.departmentId ?? null,
    })
    .then((res) => res.data);
}

export async function deleteTeam(id) {
  return axios.delete(`/teams/${id}`).then((res) => res.data);
}
